<template>
  <div v-show="loading">
    <div class="fullview">
      <div class="loading-spacer"></div>
      <v-card flat>
         <v-card-text class="text-center">
            <vue-loading 
              type="spin"
              color="#aaa"
              :size="{ width: '100px', height: '100px' }"
              >
            </vue-loading>
           <p class="mt-10" v-html="message"></p>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template'

export default {
  name: 'loading',
  components: {
    VueLoading,
  },
  props:["message"],
  data(){
    return{
      loading: false
    }
  },
  methods: {
    start() {
      this.loading = true;
    },
    end() {
      this.loading = false;
    }
  }
}
</script>

<style>
.fullview {
  width: 100%;
  height: 100%;
/*
  background: #fefefe;
*/
  background-color:rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
}
.loading-spacer {
  height: 40%;
}
</style>